import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import PageTitle from "../../../components/PageTitle";
import PageSubTitle from "../../../components/PageSubTitle";
import Button from "../../../components/Button";
import useSaveOnboarding, {
  EligibilityItemsInterface,
} from "../../../hooks/mutations/admin/useSaveOnboarding";
import { StepComponentProps } from "./index";

const Container = styled("div")(`
  height: 100vh;
  width: 100%;
`);

const InnerContainer = styled("div")(`
  width: 60%;
  margin: auto;
`);

const eligibilityChoices = [
  {
    step: 0,
    dbKey: "eligibility_employees_contractor",
    choices: [
      {
        label: "All Employees and Contractors",
        value: "employees_and_contractors",
      },
      { label: "Employees Only", value: "employees_only" },
    ],
  },
  {
    step: 1,
    dbKey: "eligibility_pay_type",
    choices: [
      { label: "All Employees", value: "all_employees" },
      { label: "Hourly Employees Only", value: "hourly_only" },
      { label: "Salaried Employees Only", value: "salary_only" },
    ],
  },
  {
    step: 2,
    dbKey: "eligibility_executives",
    choices: [
      { label: "Include Executives", value: "include_executives" },
      {
        label: "Do Not Include Executives",
        value: "do_not_include_executives",
      },
    ],
  },
];

const EligibleEmployees = ({ nextStep }: StepComponentProps) => {
  const [currentEligibilityStep, setEligibilityStep] = useState(0);
  const [choices, setChoices] = useState<EligibilityItemsInterface>({
    eligibility_employees_contractor: "",
    eligibility_pay_type: "",
    eligibility_executives: "",
  });
  const getCurrentChoices = () => {
    return eligibilityChoices[currentEligibilityStep];
  };

  const nextScreen = currentEligibilityStep + 1;
  const isNotLastChoice = nextScreen <= eligibilityChoices.length;

  // Mutations
  const { mutate: saveOnboarding, status: saveStatus } = useSaveOnboarding({
    onSuccessHandler: nextStep,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChoice = (dbKey: string, newSelection: string) => {
    setChoices({ ...choices, [dbKey]: newSelection });
    setEligibilityStep(nextScreen);
  };

  const title = isNotLastChoice ? "Employee Eligibility" : "Almost done!";
  const subTitle = isNotLastChoice
    ? "Select who can participate in this benefit."
    : "Our team will follow up with next steps for the payroll file exhange.";

  const renderChoices = () => {
    return getCurrentChoices()?.choices.map((choice) => {
      const dbKey = getCurrentChoices().dbKey;
      return (
        <Button
          key={choice.label}
          style={{ height: "60px", marginTop: "8px", marginBottom: "8px" }}
          onClick={() => handleChoice(dbKey, choice.value)}
        >
          {choice.label}
        </Button>
      );
    });
  };

  const handleComplete = async () => {
    saveOnboarding({ eligibilityItems: { ...choices } });
  };

  return (
    <Container>
      <InnerContainer>
        <PageTitle>{title}</PageTitle>
        <PageSubTitle>{subTitle}</PageSubTitle>
        {isNotLastChoice ? (
          renderChoices()
        ) : (
          <Button onClick={handleComplete}>Continue</Button>
        )}
      </InnerContainer>
    </Container>
  );
};

export default EligibleEmployees;
